import { render, staticRenderFns } from "./RoleSelectbox.vue?vue&type=template&id=3359d8f1"
import script from "./RoleSelectbox.vue?vue&type=script&lang=js"
export * from "./RoleSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports